import * as React from "react";

const Exclamation: React.FC = () => {
    return (
        <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M16.5 8C16.5 12.4183 12.9183 16 8.5 16C4.08172 16 0.5 12.4183 0.5 8C0.5 3.58172 4.08172 0 8.5 0C12.9183 0 16.5 3.58172 16.5 8ZM9.83333 12.3333C9.83333 13.0697 9.23638 13.6667 8.5 13.6667C7.76362 13.6667 7.16667 13.0697 7.16667 12.3333C7.16667 11.597 7.76362 11 8.5 11C9.23638 11 9.83333 11.597 9.83333 12.3333ZM7.16667 2.66667H9.83333L9.5 10H7.5L7.16667 2.66667Z" fill="currentColor"/>
        </svg>     
    );
};

export default React.memo(Exclamation);
